import { sortByCustomOrder } from "@/utils";
import { setExpansion, store } from "./bidStore";

export const handleBidChanges = (changes) => {
    const sortedChanges = sortByCustomOrder(changes, "model_type", [
        "bid",
        "line_group",
        "line_item",
        "line_group_running",
        "line_item_running",
        "addon",
        "comment",
        "bill",
    ]);
    sortedChanges.forEach((change) => {
        const { model_type } = change;
        if (model_type === "line_item") {
            handleLineItemChange(change, false);
        } else if (model_type === "line_group") {
            handleLineGroupChange(change, false);
        } else if (model_type === "line_item_running") {
            handleLineItemChange(change, true);
        } else if (model_type === "line_group_running") {
            handleLineGroupChange(change, true);
        } else if (model_type === "addon") {
            handleAddonChange(change);
        } else if (model_type === "bid") {
            handleBidChange(change);
        } else if (model_type === "comment") {
            handleBidCommentChange(change);
        } else if (model_type === "bill") {
            handleBillChange(change);
        }
    });
};

const shallowMutateObject = (data, targetObj) => {
    Object.keys(targetObj).forEach((key) => {
        if (key in data) {
            targetObj[key] = data[key];
        }
    });
    return targetObj;
};

const handleLineItemChange = (change, isRunning) => {
    const change_type = change.change_type;
    const lineItem = change.data;
    const hash = isRunning ? store.lineItemsRunningHash : store.lineItemsHash;
    const hashRunning = store.lineItemsRunningHash;
    const bidLineItems = isRunning
        ? store.bid.line_items_running
        : store.bid.line_items;
    if (change_type === "updated") {
        shallowMutateObject(lineItem, hash[lineItem.id]);
        if (lineItem.line_item_running) {
            shallowMutateObject(
                lineItem.line_item_running,
                hashRunning[lineItem.line_item_running.id],
            );
        }
    } else if (change_type === "created") {
        const sortOrder = lineItem.sort_order;
        const insertIndex = bidLineItems.findIndex(
            (item) => item.sort_order > sortOrder,
        );
        if (insertIndex === -1) {
            bidLineItems.push(lineItem);
        } else {
            bidLineItems.splice(insertIndex, 0, lineItem);
        }
        hash[lineItem.id] = lineItem;
    } else if (change_type === "deleted") {
        const lineItemIndex = bidLineItems.findIndex(
            (item) => item.id === lineItem.id,
        );
        if (lineItemIndex !== -1) {
            bidLineItems.splice(lineItemIndex, 1);
        }
        delete hash[lineItem.id];
    }
};

const handleLineGroupChange = (change, isRunning) => {
    const change_type = change.change_type;
    const lineGroup = change.data;
    const hash = isRunning ? store.lineGroupsRunningHash : store.lineGroupsHash;
    const hashRunning = store.lineGroupsRunningHash;
    const bidLineGroups = isRunning
        ? store.bid.line_groups_running
        : store.bid.line_groups;
    if (change_type === "updated") {
        shallowMutateObject(lineGroup, hash[lineGroup.id]);
        if (lineGroup.line_group_running) {
            shallowMutateObject(
                lineGroup.line_group_running,
                hashRunning[lineGroup.line_group_running.id],
            );
        }
    } else if (change_type === "created") {
        bidLineGroups.push(lineGroup);
        setExpansion(`group-${lineGroup.id}`, true);
        hash[lineGroup.id] = lineGroup;
    } else if (change_type === "deleted") {
        const lineGroupIndex = bidLineGroups.findIndex(
            (group) => group.id === lineGroup.id,
        );
        if (lineGroupIndex !== -1) {
            bidLineGroups.splice(lineGroupIndex, 1);
        }
        delete hash[lineGroup.id];
    }
};

const handleAddonChange = (change) => {
    const change_type = change.change_type;
    const addon = change.data;
    if (change_type === "updated") {
        shallowMutateObject(addon, store.addonsHash[addon.id]);
        const existingAddon = store.bid.addons.find((a) => a.id === addon.id);
        if (existingAddon) {
            shallowMutateObject(addon, existingAddon);
        }
    } else if (change_type === "created") {
        if (addon.line_group_id) {
            store.lineGroupsHash[addon.line_group_id].addons.push(addon);
        }
        store.bid.addons.push(addon);
        store.addonsHash[addon.id] = addon;
    } else if (change_type === "deleted") {
        if (addon.line_group_id) {
            const parentGroup = store.lineGroupsHash[addon.line_group_id];
            parentGroup.addons = parentGroup.addons.filter(
                (a) => a.id !== addon.id,
            );
        }
        store.bid.addons = store.bid.addons.filter((a) => a.id !== addon.id);
        delete store.addonsHash[addon.id];
    }
};

const handleBidChange = (change) => {
    const change_type = change.change_type;
    const bid = change.data;
    if (change_type === "updated") {
        shallowMutateObject(bid, store.bid);
    }
};

const handleBidCommentChange = (change) => {
    const comment = change.data;
    const change_type = change.change_type;
    if (change_type === "created") {
        store.bid.comments.push(comment);
    } else if (change_type === "deleted") {
        store.bid.comments = store.bid.comments.filter(
            (c) => c.id !== comment.id,
        );
    } else if (change_type === "updated") {
        const existingComment = store.bid.comments.find(
            (c) => c.id === comment.id,
        );
        if (existingComment) {
            shallowMutateObject(comment, existingComment);
        }
    }
};

const handleBillChange = (change) => {
    const bill = change.data;
    const change_type = change.change_type;
    if (change_type === "created") {
        store.bid.bills.push(bill);
    } else if (change_type === "deleted") {
        store.bid.bills = store.bid.bills.filter((b) => b.id !== bill.id);
    } else if (change_type === "updated") {
        const existingBill = store.bid.bills.find((b) => b.id === bill.id);
        if (existingBill) {
            shallowMutateObject(bill, existingBill);
        }
    }
    store.bid.bills = [...store.bid.bills];
};
